import React from 'react';

import { useStoreThemeProviderLazyQuery } from 'generated/graphql';



export interface IData {
  primaryColor: string;
  secondaryColor: string;
  buttonColor: string;
}

export function useQuery(storeId: string) {
  const [fnQuery, tuple] = useStoreThemeProviderLazyQuery({});



  React.useEffect(
    () => {
      if (storeId) {
        fnQuery({
          variables: {
            storeId
          }
        });
      }
    },
    [
      fnQuery,
      storeId
    ]
  );



  return React.useMemo(
    () => {
      const data: IData = {
        buttonColor: tuple.data?.storeBrand?.buttonColorHex ?? '',
        primaryColor: tuple.data?.storeBrand?.primaryColorHex ?? '',
        secondaryColor: tuple.data?.storeBrand?.secondaryColorHex ?? ''
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
